/** @jsxImportSource @emotion/react */

import { vars } from "@imwebme/clay-token";
import type { PropsWithChildren, Ref } from "react";
import { forwardRef } from "react";
import type { ClayProps } from "..";
import { Flex, Label } from "..";
import { TextfieldAddon } from "./Textfield.addon";
import { TextfieldBox, TextfieldNoAddon } from "./Textfield.box";
import { TextfieldHelperText } from "./Textfield.helperText";
import { TextfieldInput, TextfieldNumericInput } from "./Textfield.input";

const TextfieldSet = forwardRef(
  (
    { children, ...restProps }: PropsWithChildren<ClayProps<"fieldset">>,
    ref: Ref<HTMLFieldSetElement>,
  ) => {
    return (
      <Flex.Column as="fieldset" ref={ref} gap={vars.spacing[15]} {...restProps}>
        {children}
      </Flex.Column>
    );
  },
);

TextfieldSet.displayName = "Textfield.Set";

const TextfieldNamespace = Object.assign(TextfieldNoAddon, {
  Set: TextfieldSet,
  Input: TextfieldInput,
  NumericInput: TextfieldNumericInput,
  Legend: Label,
  Box: TextfieldBox,
  Addon: TextfieldAddon,
  HelperText: TextfieldHelperText,
});

export { TextfieldNamespace as Textfield };
